<template>
    <div class="naHeader">
        <div class="head">
            Evaluation Overview
        </div>
    </div>
    <div class="na-Header">
        <div class="na-Filter">
            <div class="na-FilterCell">
                <div class="na-FilterLabel">Evaluation Round:</div>
                <div class="na-FilterBox">
                    <DxSelectBox :data-source="rtgList"
                                 :search-enabled="true"
                                 :show-clear-button="false"
                                 display-expr="RtgName"
                                 value-expr="RtgId"
                                 :width="300"
                                 v-model:value="selectedRtgId">
                    </DxSelectBox>
                </div>
            </div>
        </div>
        <div class="na-list">
            <DxDataGrid v-model:data-source="evaluationList"
                        :columns="columnList"
                        :ref="gridKey"
                        v-on:initialized="gridInitialized"
                        v-on:contentReady="gridContentReady"
                        v-model:selected-row-keys="selectedRowKeys"
                        key-expr="TopicId"
                        @selection-changed="onSelectionChanged"
                        :activeStateEnabled="true"
                        :allowColumnReordering="true"
                        :allowColumnResizing="true"
                        :rowAlternationEnabled="true"
                            @exporting="onExporting"
                        :show-borders="true">
                <DxColumnChooser :enabled="true" />
                <DxColumnFixing :enabled="true" />
                <DxFilterPanel :visible="true" />
                <DxFilterRow :visible="true" />
                <DxHeaderFilter :visible="true" />
                <DxSearchPanel :visible="true" placeholder="Search..." />
                <DxLoadPanel :enabled="false" />
                <DxScrolling row-rendering-mode="standard" />
                <DxPaging :page-size="20" />
                <DxPager :visible="true"
                          :allowed-page-sizes="pageSizes"
                         :display-mode="full"
                         :show-page-size-selector="true"
                         :show-info="true"
                         :show-navigation-buttons="true" />
                <DxSorting mode="multiple" />
                <DxGroupPanel :visible="true" />
                <DxStateStoring :enabled="true"
                                type="session"
                                :storage-key="gridKey"
                                :custom-load="loadState"
                                :custom-save="saveState" />
                <DxExport :enabled="true"
                          :allow-export-selected-data="true" />
                <DxSelection :mode="selectionMode" select-all-mode="allPages" allow-select-all="true" />
                <DxToolbar>
                    <DxItem name="groupPanel" />
                    <!--<DxItem name="searchPanel" />-->
                    <DxItem name="fullTextSearchPanel">
                        <div class="fullTextFilterBox">
                            <DxTextBox v-model:value="searchText" :showClearButton="true" @enterKey="search" @keyDown="searchChanged" @valueChanged="searchValueChanged" />
                            <div v-if="searchVisible" class="na-search-icon">
                                <DxButton stylingMode="text" icon="fas fa-search" hint="Volltextsuche" @click="search"></DxButton>
                            </div>
                        </div>
                    </DxItem>
                    <DxItem name="exportButton" cssClass="mnExport" showText="false" />
                    <DxItem name="columnChooserButton"
                            locate-in-menu="auto"
                            location="after" />
                    <DxItem>
                        <DxButton icon="dx-icon dx-icon-clear" hint="Ansicht und Filter zurücksetzen" @click="resetState"></DxButton>
                    </DxItem>
                    <!--<DxItem>
                        <DxButton icon="fas fa-sync" hint="Filter zurücksetzen" @click="resetFilter"></DxButton>
                    </DxItem>-->
                </DxToolbar>


                <!--<DxStateStoring :enabled="true"
                type="localStorage"
                storage-key="storage" />-->

                <template #commentTemplate="{ data  }">
                    <div class="grdCommentBox" @click="showComments(data)" v-if="accessList._300511">
                        <div class="grdCommentIcon"><i class="fas fa-comments"></i></div>
                        <div class="grdCommentUnreadCountBox">
                            <div class="grdCommentUnreadCount" v-if="data.data.CommentsUnreadCount>0">{{data.data.CommentsUnreadCount}}</div>
                        </div>
                        <div class="grdCommentCount">{{data.value}}</div>
                    </div>
                </template>
                <template #plainTemplate="{ data }">
                    {{data.value}}
                </template>
                <template #percentTemplate="{ data }" class="pq-td-center">
                    {{ Number.parseFloat(data.value).toFixed(0) }} %
                </template>
                <template #flagTemplate="{ data }">
                    <div class="flgBox" :id="'flagMenu' + data.data.TopicId">
                        <i v-bind:class="['fa', 'fa-flag', 'FlagMenuItem-' + data.value]"></i>
                        <DxMenu :data-source="getFlagMenuItems(data)"
                                items-expr="items"
                                orientation="horizontal"
                                :hideSubmenuOnMouseLeave="true"
                                @item-click="function(e) { flagItemClick(e, data) }"
                                itemTemplate="itemTemplate"
                                show-first-submenu-mode="onHover"
                                show-submenu-mode="onHover">
                            <template #itemTemplate="{ data }">
                                <div>
                                    <div class="pq-menu-item">
                                        <i v-bind:class="data.icon"></i>
                                        <div class="pq-menu-txt">{{data.text}}</div>
                                    </div>
                                </div>
                            </template>
                        </DxMenu>
                    </div>
                </template>
                <template #actionTemplate="{data }">
                    <div class="MenMore">
                        <DxMenu :data-source="getRowMenuItems(data)"
                                items-expr="items"
                                orientation="horizontal"
                                :element-attr="{TopicId: data.value}"
                                :hideSubmenuOnMouseLeave="true"
                                @item-click="function(e) { menuItemClick(e, data.value) }"
                                itemTemplate="itemTemplate"
                                show-first-submenu-mode="onHover">
                            <template #itemTemplate="{ data }">
                                <div>
                                    <div class="pq-menu-item">
                                        <i v-bind:class="data.icon"></i>
                                        <div class="pq-menu-txt">{{data.text}}</div>
                                    </div>
                                </div>
                            </template>
                        </DxMenu>
                    </div>
                    <!--<div class="pqMenuCell">
        <i class="pqMenuElipsis fas fa-ellipsis-v">
            <div class="pqMenu">
                <div class="pqMnCommand" @click="viewTopic(data.value)"><i class="far fa-eye"></i>View</div>
                <div v-if="access.allowUpdate" style="display:contents;">
                    <div class="pqMnCommand" @click="editExperts(data.value)"><i class="fas fa-pen"></i>Edit</div>
                </div>
            </div>
        </i>
    </div>-->
                </template>
                <template #sfTemplate="{ data }">
                    <div>
                        <span v-html="data.value"></span>
                    </div>
                </template>
                <template #htmlTemplate="{ data }">
                    <div>
                        <span class="pqTooltip" v-html="data.value"></span>
                    </div>
                </template>
                <template #formattedAvg="{ data }">
                    <div class="pqAvg" :style="{ backgroundColor: formatAvgColor(data.value)}">
                       
                        <div v-if="!data.value">
                            Not voted yet
                        </div>
                        <div v-if="data.value">
                            {{ Number.parseFloat(data.value).toFixed(1) }}
                        </div>
                    </div>
                
                </template>
            </DxDataGrid>
        </div>
        <div class="puFooterButtons">
            <div class="puFooterButton">
                <DxButton text="Export to Excel" @click="exportToExcel"></DxButton>
            </div>
            <div class="puFooterButton">
                <DxButton text="Assign Experts" :disabled="!hasSelection" @click="showBulkExpertsSelection"></DxButton>
            </div>
            <div class="puFooterButton">
                <DxButton text="Download PDFs" :disabled="!hasSelection" @click="downloadPdfs"></DxButton>
            </div>
        </div>
        <DxPopup v-model:visible="popupVisible" :title="popupTitle" width="auto" height="auto" :content-template="popupTemplate">
            <template #changeStatus>
                <div class="puBox">
                    <div class="puCell">
                        <div class="puLabel">Neuer Status</div>
                        <div class="puValue">
                            <DxSelectBox :data-source="newStatusList"
                                         :show-clear-button="false"
                                         display-expr="StatusName"
                                         value-expr="StatusID"
                                         v-model:value="newStatusId">
                            </DxSelectBox>
                        </div>
                    </div>
                    <div class="puButtons">
                        <div class="puLeftButtons">
                            <DxButton text="Abbrechen" @click="hidePopup" />
                        </div>
                        <div class="puRightButtons">
                            <DxButton text="Status ändern" @click="changeState" :disabled="!newStatusId>0" />
                        </div>
                    </div>
                </div>
            </template>
            <template #addToCart>
                <div class="puBox">
                    <div class="puCell">
                        <div class="puLabel">Bookmark-Liste:</div>
                        <div class="puValue">
                            <DxSelectBox :data-source="cartList"
                                         :show-clear-button="true"
                                         :accept-custom-value="true"
                                         @custom-item-creating="addingCart"
                                         display-expr="CrtFullName"
                                         width="350"
                                         placeholder="Namen für neue Liste angeben oder auswählen..."
                                         v-model:value="selectedCartForAction">
                            </DxSelectBox>
                        </div>
                    </div>
                    <div class="puButtons">
                        <div class="puLeftButtons">
                            <DxButton text="Abbrechen" @click="hidePopup" />
                        </div>
                        <div class="puRightButtons">
                            <DxButton text="Themen zu Bookmarkliste hinzufügen" @click="addToCart" :disabled="selectedCartForAction == null" />
                        </div>
                    </div>
                </div>
            </template>
            <template #dlgExperts>
                <div class="puBox">
                    <div class="puCell">
                        <DxDataGrid v-model:data-source="expertsList"
                                    :width="300"
                                    key-expr="UsrId"
                                    v-model:selected-row-keys="selectedExpertsForAction">
                            <DxColumn caption='Expert' data-type='string' data-field='UsrFullName' />
                            <DxSelection mode="multiple" select-all-mode="allPages" allow-select-all="true" showCheckBoxesMode="always" />
                        </DxDataGrid>
                    </div>
                    <div class="puButtons">
                        <div class="puLeftButtons">
                            <DxButton text="Assign Experts" @click="assignExperts" :disabled="!selectedExpertsForAction || selectedExpertsForAction.length == 0" />
                        </div>
                        <div class="puRightButtons">
                            <DxButton text="Cancel" @click="hidePopup" />
                        </div>
                    </div>
                </div>
            </template>
            <template #comments>
                <div class="puBox">
                    <div class="puCell cmtBox">
                        <div v-for="message in commentList" :key="message.ComId" class="cmtRecord">
                            <div class="cmtHeader">
                                <div class="cmtDate">
                                    {{   moment(message.ComCreatedOn).format('DD.MM.YYYY hh:mm')  }}:
                                </div>
                                <div class="cmtUser">
                                    {{ message.UsrFullName }}
                                </div>
                            </div>
                            <div class="cmtText" v-html="message.ComText"></div>
                        </div>
                    </div>
                    <div class="puButtons">
                        <div class="puLeftButtons">
                            <DxButton text="Schließen" @click="hidePopup" />
                        </div>
                        <div class="puRightButtons">
                            <DxButton text="Schließen und als gelesen markieren" @click="markCommentAsRead()" v-if="currentTopic.CommentsUnreadCount > 0" />
                            <DxButton text="Neuer Kommentar" @click="createNewComment()" v-if="accessList._300514" />
                        </div>
                    </div>
                </div>
            </template>
            <template #newComment>
                <div class="puBox">
                    <div class="puCell cmtTextBox">
                        <DxTextArea v-model:value="commentText" height="400" width="700" />
                    </div>
                    <div class="puButtons">
                        <div class="puLeftButtons">
                            <DxButton text="Schließen" @click="hidePopup" />
                        </div>
                        <div class="puRightButtons">
                            <DxButton text="Absenden" @click="saveComment()" v-if="accessList._300514" />
                        </div>
                    </div>
                </div>
            </template>
        </DxPopup>
    </div>
</template>
<script>
    import {
        DxDataGrid,
        DxColumn,
        DxColumnChooser,
        DxColumnFixing,
        DxFilterRow,
        DxHeaderFilter,
        DxSearchPanel,
        DxLoadPanel,
        DxScrolling,
        DxSorting,
        DxPaging,
        DxPager,
        DxFilterPanel,
        DxStateStoring,
        DxGroupPanel,
        DxToolbar,
        DxItem,
        DxExport,
        DxSelection
    } from 'devextreme-vue/data-grid'
    import DxTextBox from 'devextreme-vue/text-box'
    import DxSelectBox from 'devextreme-vue/select-box'
    import DxButton from 'devextreme-vue/button'
    import DxTextArea from 'devextreme-vue/text-area'
    import DxMenu from "devextreme-vue/menu"
    import DxPopup from "devextreme-vue/popup"
    import axios from 'axios'
    import moment from 'moment'
    import { exportDataGrid } from 'devextreme/excel_exporter';
    import { Workbook } from 'exceljs';
    import saveAs from 'file-saver';
    import $ from 'jquery';
    import { confirm } from "devextreme/ui/dialog"

    const gridServiceUri = "WebApi.asmx/api/dataGrid"
    const gridKey = "IdeaEvaluationOverviewVx"
    const filterKey = gridKey + "Filter"

    export default {
        name: 'TopicOverview',
        components: {
            DxDataGrid,
            DxColumnChooser,
            DxColumn,
            DxColumnFixing,
            DxFilterRow,
            DxHeaderFilter,
            DxSearchPanel,
            DxLoadPanel,
            DxScrolling,
            DxSorting,
            DxSelectBox,
            DxPaging,
            DxPager,
            DxFilterPanel,
            DxStateStoring,
            DxGroupPanel,
            DxButton,
            DxToolbar,
            DxItem,
            DxExport,
            DxMenu,
            DxTextBox,
            DxSelection,
            DxPopup,
            DxTextArea
        },

        data() {
            return {
                CartBoxKey: 0,
                ClusterBoxKey: 0,
                searchVisible: true,
                pageSizes: [5, 10, 20,50],
                currentTopic: null,
                filterStateInternal: {},
                selectedRowKeys: [],
                selectedExpertsForAction: [],
                popupTemplate: '',
                popupVisible: false,
                popupTitle: '',
                commentText: '',
                gridKey,
                filterKey,
                filter: {},
                storageKey: 'ideaEvaluationOverviewVx',
                pageIndex: 0,
                selectedRtgId: null,
                isLoaded: false,
            }
        },
        computed: {
            grid: function () {
                const ref = this.$refs[this.gridKey]
                if (ref) {
                    window.grid = ref.instance
                    return ref.instance
                }
                return null
            },
            accessList() {
                return this.$store.state.accessStore.accessList
            },
            filterState: {
                cache: false,
                set: function (val) {

                    console.log("filterState-set", val)
                    localStorage.setItem(filterKey, JSON.stringify(val));
                    this.filterStateInternal = val
                },
                get: function () {

                    console.log("filterState-get")
                    return this.filterStateInternal
                }
            },
            selectionMode() {
                return "multiple"
            },
            hasSelection() {
                return this.selectedRowKeys && this.selectedRowKeys.length > 0
            },
            evaluationList() {
                var result = this.$store.state.genericListStore.evaluationList
                return result
            },
            expertsList() {
                var result = this.$store.state.genericListStore.expertsList
                return result
            },
            expertsFilter() {
                return this.expertsList.map(m => {
                    return {
                        text: m.UsrFullName,
                        value: ["Experts", "contains", m.UsrFullName]
                    }
                })
            },
            ratingFields() {
                var result = this.$store.state.genericListStore.ratingFields
                return result
            },
            rtgList() {
                var result = this.$store.state.ratingTypeGroupStore.ratingTypeGroupSimpleList
                return result
            },
            commentList() {
                var result = this.$store.state.commentStore.commentList
                return result
            },
            columnList() {
                var result = [

                    {
                        caption: '', width: 30, cellTemplate: 'actionTemplate', dataType: "number", dataField: '$id',
                        allowFiltering: false, allowHeaderFiltering: false, allowResizing: false, allowColumnReordering: false, fixed: true, alignment: "center"
                    },
                    {
                        caption: '', width: 30, cellTemplate: 'flagTemplate', dataType: "number", dataField: 'Flag',
                        allowResizing: false, allowColumnReordering: false, fixed: true, visible: this.accessList._300561, alignment: "center"
                    },
                    { caption: 'ID', dataType: "number", dataField: 'SchaltzeitId', width: 100 },
                    { caption: 'Name of Solution', dataType: 'string', dataField: 'Title' },
                    { caption: 'Company', dataType: 'string', dataField: 'UsrCompany' },
                    { caption: 'Country', dataType: 'string', dataField: 'CouName' },
                    { caption: 'Status', dataType: 'string', dataField: 'StatusName' },
                    { caption: 'Fullfillment', dataType: 'number', dataField: 'TpcFullfillment', cellTemplate: 'percentTemplate', alignment: "center" },
                    { caption: 'Experts', dataType: 'string', dataField: 'Experts', cellTemplate: 'htmlTemplate', headerFilter: { dataSource: this.expertsFilter } },
                    { caption: 'Average Score', dataType: 'string', dataField: 'RatScoreAvg', cssClass: "pq-td-avg", cellTemplate: 'formattedAvg' },
                ]
                var n = 1
                var cols = this.ratingFields.map(m => {
                    return {
                        dataField: 'RatAll_' + n++,
                        caption: m.RtyCaption,
                        cellTemplate: "formattedAvg",
                        cssClass: "pq-td-avg",
                        format: {
                            type: "fixedPoint",
                            precision: 1
                        }
                    }
                })
                return result.concat(cols)
            },
            loaded() {
                console.log("loaded")
                return this.rtgList && this.rtgList.length > 0
            },
        },
        watch: {
            rtgList: function (newVal) {
                this.selectedRtgId = newVal && newVal.length > 0 ? newVal[0].RtgId : null;
            },
            selectedRtgId: function (newVal, oldVal) {
                if (newVal && newVal != oldVal) {
                    this.filterState.selectedRtgId = newVal
                    this.loadData()
                }
            },
            searchText: function (newVal) {
                this.filterState.searchText = newVal
            },
            evaluationList: function () {
                if (this.grid != null)
                    this.grid.pageIndex(this.pageIndex)
            },
            loaded: function (newVal, oldVal) {
                console.log("loaded-watch")
                if (!this.isLoaded && newVal && !oldVal) {
                    this.isLoaded = true
                }
            },
        },
        created: function () {
            this.moment = moment
        },
        mounted: function () {

            console.log("mounted")
            this.$store.dispatch("getRatingTypeGroupSimpleList", {})
            this.$store.dispatch("getAccessList", { tokenList: ["300231", "300511", "300514", "200221", "300561"] })
            this.$store.dispatch("getExpertsList", { RtgId: this.selectedRtgId })
            var filter = localStorage.getItem(filterKey)
            if (filter == "null") {
                filter == "{}"
            }
            this.filterState = filter > '' ? JSON.parse(filter) : {}
            var filterState = this.filterState
            if (filterState) {
                console.log("mounted-2", filterState)
                this.searchText = filterState.searchText ? filterState.searchText : ""
                this.selectedRtgId = filterState.selectedRtgId
                //this.loadData()
            }
        },
        methods: {
            onExporting(e) {
                e.component.beginUpdate();
                const workbook = new Workbook();
                const worksheet = workbook.addWorksheet('Data');
                exportDataGrid({
                    component: e.component,
                    worksheet: worksheet
                }).then(function () {
                    workbook.xlsx.writeBuffer().then(function (buffer) {
                        saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'Data.xlsx');
                    });
                }).then(function () {
                    e.component.endUpdate();
                });
            },
            getRowMenuItems(data) {
                var result = [{
                    id: 1,
                    topic: data.data,
                    text: '',
                    icon: 'pqMenuElipsis fas fa-ellipsis-v',
                    visible: true,
                    items: [{ text: 'Read', id: 'view', icon: "ca-read far fa-eye", visible: true },
                        { text: 'Experts', id: 'experts', icon: "fas fa-pen", visible: data.data.AllowEdit }]
                }]
                return result
            },
            formatAvgColor: function (value) {
                if (value !== null) {
                    var perc = (5 - value) / 5;
                    var color = this.percentageToHsl(perc, 120, 0, 100, 75, 100);
                    return color
                    //container.attr("class", "ratCell ratPerc" + Math.floor(options.value));
                    //container.html("<div class='evalNumber'>").text(options.text);
                    //container.css("background", color);
                }
            },
            getFlagMenuItems(data) {
                var result = [{
                    id: -1,
                    topic: data.data,
                    text: '',
                    icon: 'flmArea fa fa-flag FlagMenuItem',
                    visible: true,
                    items: [
                        { text: ' ', id: 0, icon: "fa fa-flag FlagMenuItem-0" },
                        { text: '1', id: 1, icon: "fa fa-flag FlagMenuItem-1" },
                        { text: '2', id: 2, icon: "fa fa-flag FlagMenuItem-2" },
                        { text: '3', id: 3, icon: "fa fa-flag FlagMenuItem-3" },
                        { text: '4', id: 4, icon: "fa fa-flag FlagMenuItem-4" },
                        { text: '5', id: 5, icon: "fa fa-flag FlagMenuItem-5" },
                        { text: '6', id: 6, icon: "fa fa-flag FlagMenuItem-6" },
                    ]
                }]
                return result
            },
            resetFilter: function () {
                this.grid.clearFilter()
                this.selectedRtgId = null
                this.searchText = null
            },
            resetState: function () {
                this.grid.state(null)
                this.clearSearch()
                this.resetFilter()
                this.loadData(true)
            },
            search: function () {
                this.filterState.searchText = this.searchText
                this.loadData()
                this.searchVisible = false
            },
            clearSearch: function () {
                this.searchText = ""
            },
            searchChanged: function () {
                this.searchVisible = true
            },
            searchValueChanged: function (e) {
                if (e.previousValue && e.value == "" && e.previousValue != "") {
                    this.loadData()
                    this.searchVisible = true
                }
            },
            goToMyVoting: function () {
                window.LoadPanel.Show()
                window.location.href = window.location.pathname + "?action=myVoting"
            },
            loadData: function (force) {
                this.$store.dispatch("getEvaluationList", { rtgId: this.selectedRtgId })

                console.log("loadData")
                if (this.grid != null) {
                    console.log("beginUpdate")
                    //this.grid.beginCustomLoading()
                }
                this.filterState = {
                    selectedRtgId: this.selectedRtgId,
                    searchText: this.searchText,
                }
                console.log("filterState", this.filterState)
                const filter = {
                    RtgId: this.selectedRtgId,
                    Search: this.searchText,
                }
                if (JSON.stringify(filter) != JSON.stringify(this.filter) || force == true) {
                    this.filter = filter
                }
            },
            viewTopic: function (data) {
                window.LoadPanel.Show()
                var rec = this.evaluationList.find(m => m.$id == data);
                this.grid.selectAll().done(x => {
                    const evaluationList = JSON.stringify(x.map(r => r.TopicId))
                    this.grid.deselectAll().done(function () {
                        window.location.href = window.location.pathname + "?action=view&id=" + rec.TopicId + "&list=" + evaluationList
                    })
                })
            },
            editExperts: function (data) {
                window.LoadPanel.Show()
                var rec = this.evaluationList.find(m => m.$id == data);
                var rtgId = this.selectedRtgId
                this.grid.selectAll().done(x => {
                    const evaluationList = JSON.stringify(x.map(r => r.TopicId))
                    this.grid.deselectAll().done(function () {
                        window.location.href = window.location.pathname + "?action=experts&id=" + rec.TopicId + "&list=" + evaluationList + "&rtgId=" + rtgId
                    })
                })
            },
            loadStateX() {
                return axios.get(gridServiceUri + '/GetState', { params: { ControlName: "TopicOverview.vue", ViewName: "GrdMain" } })
                    .then(res => {
                        return res.data.Data
                    })
            },
            loadState() {
                const stateTxt = localStorage.getItem(this.storageKey)
                if (stateTxt && stateTxt > '') {
                    console.log("loadState")
                    var state = JSON.parse(stateTxt);
                    state.columns = state.columns.filter(m => {
                        return this.columnList.indexOf(u => {
                            return u.dataField == m.dataField
                        })
                    })
                    this.pageIndex = state.pageIndex
                    return state
                }
                else {
                    return null
                }
            },
            saveState(state) {
                localStorage.setItem(this.storageKey, JSON.stringify(state));
            },
            gridInitialized(arg) {
                console.log({ arg, name: "gridInitialized" })
            },
            gridContentReady(arg) {
                console.log({ arg, name: "gridContentReady" })
                console.log("endCustomLoading")
                this.grid.endCustomLoading()
                if (this.selectedRowKeys != []) {
                    this.selectedRowKeys = []
                    this.grid.deselectAll()
                }
            },
            menuItemClick(e, id) {
                switch (e.itemData.id) {
                    case "experts":
                        window.LoadPanel.Show()
                        this.editExperts(id)
                        return
                    case "view":
                        window.LoadPanel.Show()
                        this.viewTopic(id)
                        return
                }
            },
            percentageToHsl(percentage, hue0, hue1, s, l, a) {
                s = s ? s : 1;
                l = l ? l : .5;
                a = a ? a : 1;
                var hue = (percentage * (hue1 - hue0)) + hue0;
                return 'hsl(' + hue + ', ' + s + '%, ' + l + '%, ' + a + '%)';
            },
            flagItemClick(e, data) {
                if (e.itemData.id >= 0) {
                    data.component.selectRows(data.key)
                    this.$store.dispatch("setTopicFlag", { FlagNr: e.itemData.id, Id: data.data.TopicId })
                        .then(() => {
                            data.value = e.itemData.id
                            data.component.selectRows()
                        });
                }
            },
            onSelectionChanged({ selectedRowKeys }) {
                this.selectedRowKeys = selectedRowKeys
            },
            showChangeState() {
                this.popupTemplate = "changeStatus"
                this.popupTitle = "Status ändern"
                this.popupVisible = true
            },

            hidePopup() {
                this.popupVisible = false
            },
            changeState() {
                if (this.newStatusId > 0 && this.selectedRowKeys && this.selectedRowKeys.length > 0) {
                    var args = JSON.stringify({ IdList: this.selectedRowKeys, StatusId: this.newStatusId })
                    this.$store.dispatch("bulkChangeStatus", args)
                    this.popupVisible = false
                    this.resetSelection()
                }
            },
            showAddToCart() {
                this.popupTemplate = "addToCart"
                this.popupTitle = "Zur Bookmark-Liste hinzufügen"
                this.popupVisible = true
            },
            showAddToCluster() {
                this.popupTemplate = "addToCluster"
                this.popupTitle = "Zu Cluster hinzufügen"
                this.popupVisible = true
            },
            downloadPdfs() {
                var result = confirm("Do you really want to download the PDFs for the selected entries.", "Bulk Download");
                var keys = encodeURIComponent(JSON.stringify(this.selectedRowKeys))
                
                result.done(function (dialogResult) {
                    if (dialogResult) {
                        var arg = "?keys=" + keys;
                        window.open("BulkDownloadPDF.aspx" + arg, "_blank");
                    }
                });
            },
            exportToExcel() {
                var rtgId = this.selectedRtgId
                $("form").attr("action", window.location.pathname + "?action=export&rtgId=" + rtgId).submit();
            },
            assignExperts() {
                var args = { rtgId: this.selectedRtgId, topicIdList: this.selectedRowKeys, usrIdList: this.selectedExpertsForAction }
                this.$store.dispatch("assignExperts", args).then(() => {
                    this.popupVisible = false
                    this.loadData(true)
                })
            },
            showBulkExpertsSelection() {
                this.popupTemplate = "dlgExperts"
                this.popupTitle = "Bulk Assignement of Experts"
                this.selectedExpertsForAction = []
                this.popupVisible = true
            },
            showRemoveFromCart() {
                this.popupTemplate = "removeFromCart"
                this.popupTitle = "Von Bookmark-Liste entfernen"
                this.popupVisible = true
            },
            showRemoveFromCluster() {
                this.popupTemplate = "removeFromCluster"
                this.popupTitle = "Von Cluster entfernen"
                this.popupVisible = true
            },
            showEditCart() {
                this.popupTemplate = "editCart"
                this.popupTitle = "Bookmark bearbeiten"
                this.popupVisible = true
            },
            hideAddCart() {
                this.popupVisible = false
            },
            addingCart(e) {
                e.customItem = { CrtId: 0, CrtName: e.text, CrtFullName: e.text }
                this.cartList.push(e.customItem)
            },
            addingCluster(e) {
                e.customItem = { TopicId: 0, Title: e.text }
                this.clusterList.push(e.customItem)
            },
            resetSelection() {
                if (this.grid) {
                    this.grid.clearSelection()
                }
            },
            markCommentAsRead() {
                this.$store.dispatch("setCommentAsRead", { TopicId: this.currentTopic.TopicId }).then(() => {
                    this.currentTopic.CommentsUnreadCount = 0
                })
                this.popupVisible = false
            },
            showComments(data) {
                this.currentTopic = data.data
                this.$store.dispatch("getCommentsForTopic", { TopicId: data.data.TopicId }).then(() => {
                    if (this.currentTopic.CommentsCount > 0) {
                        this.popupTemplate = "comments"
                        this.popupTitle = "Kommentare"
                        this.popupVisible = true
                    }
                    else {
                        this.createNewComment()
                    }
                })
            },
            saveComment() {
                this.$store.dispatch("saveTopicComment", { TopicId: this.currentTopic.TopicId, Comment: this.commentText }).then(() => {
                    this.commentText = ""
                    if (!this.currentTopic.CommentsCount) {
                        this.currentTopic.CommentsCount = 0
                    }
                    this.currentTopic.CommentsCount++

                    if (!this.currentTopic.CommentsOwnCount) {
                        this.currentTopic.CommentsOwnCount = 0
                    }
                    this.currentTopic.CommentsOwnCount++
                })
                this.popupVisible = false
            },
            createNewComment() {
                this.popupTemplate = "newComment"
                this.popupTitle = "Kommentar erstellen"
                this.popupVisible = true
            }
        }
    }
</script>
<style scoped>


    .pq-menu-item {
        display: flex;
        gap: 7px;
    }

        .pq-menu-item i {
            padding-top: 3px;
        }

    .pqAvg {
        display: table-cell;
        text-align: center;
        vertical-align: middle;
    }

    .dx-datagrid-rowsview .dx-row td.pq-td-avg {
        display: contents;
    }

    .na-list .dx-widget {
        max-width: none;
    }
    .mni-read, .mni-edit {
        display: none;
    }

    .frm-read .mni-view {
        display: block;
    }

    .frm-edit .mni-edit {
        display: block;
    }

    .na-FilterCell {
        display: flex;
        gap: 5px;
        align-items: center;
    }

    .na-Filter {
        display: flex;
        flex-direction: row;
        gap: 15px;
    }

    form .dx-loadpanel-content-wrapper * {
        display: none;
    }
     

    .mnExport div {
        background-color: var(--main-color-1);
        border-radius: 5px;
        height: 29px;
    }

        .mnExport div i:before {
            color: white;
        }

    .pqMenu .dx-menu-item-popout-container {
        display: none !important;
    }

    #app .pqMenu li {
        margin-left: -4px;
    }

    .fullTextFilterBox {
        display: grid;
        grid-template-columns: 1fr 0;
    }

        .fullTextFilterBox .na-search-icon {
            position: relative;
            left: -26px;
            background: white;
            height: 20px;
            width: 20px;
            top: 2px;
        }

            .fullTextFilterBox .na-search-icon i {
                color: gray;
            }

    .puCell {
        display: grid;
        grid-template-columns: auto auto;
        align-items: center;
        padding-bottom: 10px;
        gap: 20px;
    }

    .puButtons {
        display: flex;
        justify-content: space-between;
        gap: 20px;
    }

    .puRightButtons {
        display: flex;
        gap: 10px;
    }

    .puFooterButtons {
        display: flex;
        gap: 10px;
        padding-top: 20px;
    }

    .naHeader {
        display: grid;
        grid-template-columns: auto auto;
    }

    .naTopControls {
        display: flex;
        justify-content: right;
        gap: 20px;
        padding:20px;
    }

    .grdCommentBox {
        display: grid;
        grid-template-columns: 15px 5px;
        cursor: pointer;
    }

    .grdCommentUnreadCount {
        margin-top: -5px;
        font-size: 10px;
        color: white;
        background: red;
        width: 13px;
        height: 13px;
        text-align: center;
        border-radius: 6px;
    }

    .grdCommentCount {
        font-size: 10px;
        margin-top: -6px;
    }

    .grdCommentIcon {
        font-size: 19px;
    }

    .cmtBox {
        display: grid;
        grid-template-columns: auto;
        width: 800px;
        max-height: 300px;
        overflow-y: scroll;
        margin-bottom: 10px;
    }

    .cmtTextBox .dx-texteditor-container {
        width: 100%;
        height: 300px;
    }

    .cmtHeader {
        font-weight: bold;
        display: flex;
        margin-bottom: 2px;
        gap: 2px;
    }

    .flmArea {
        position: relative;
        top: -13px;
        left: -18px;
        color: transparent;
    }

    i.fa.fa-flag {
        font-size: 16px;
    }


    .CmdBtn.Flag {
        padding-left: 8px;
    }

    .FlagMenuPopup .dx-submenu {
        width: 35px;
        padding: 2px;
    }

    .Flag i.dx-icon {
        font-size: 17px;
        margin-left: -4px;
    }

    .FlagColor-0 i.dx-icon, .FlagMenuItem-0 {
        color: lightgray;
    }

    .FlagColor-1 i.dx-icon, .FlagMenuItem-1 {
        color: blue;
    }

    .FlagColor-2 i.dx-icon, .FlagMenuItem-2 {
        color: green;
    }

    .FlagColor-3 i.dx-icon, .FlagMenuItem-3 {
        color: red;
    }

    .FlagColor-4 i.dx-icon, .FlagMenuItem-4 {
        color: yellow;
    }

    .FlagColor-5 i.dx-icon, .FlagMenuItem-5 {
        color: violet;
    }

    .FlagColor-6 i.dx-icon, .FlagMenuItem-6 {
        color: brown;
    }

    .FlagMenuItem-Txt {
        width: 162px;
        white-space: normal;
        position: absolute;
        top: -172px;
        left: 35px;
        display: block;
        background: white;
        padding: 12px;
    }
</style>